import classNames from 'classnames';
import { FC, HTMLAttributes, StyleHTMLAttributes } from 'react';

export type IconNames = 'access_time' | 'add' | 'arrow_back_ios' | 'arrow_forward_ios' | 'arrow_forward' | 'bolt'
| 'calendar_month'| 'calendar_today' | 'check_circle' | 'close' | 'eco' | 'error_outline' | 'error' | 'event_note'
| 'expand_more' | 'info_fill' | 'info' | 'location_on' | 'mail' | 'open_in_new' | 'paper' | 'phone'
| 'photo_camera' | 'photo_library' | 'push_pin'
| 'room' | 'schedule' | 'search' | 'star' | 'undo' | 'wysiwyg';


interface IconProps {
  ariaHidden?: boolean;
  className?: string;
  color?: string;
  isPartnerFontColor?: boolean;
  name: IconNames;
  size?: number;
  style?: StyleHTMLAttributes<HTMLAttributes<HTMLElement>['style']>;
}

const MaterialIcon: FC<IconProps> = ({ name, ariaHidden, className, isPartnerFontColor, style, size, color }) => {
  const iconStyles = classNames('material-icons', className, {
    'partner-font-color': !!isPartnerFontColor && !color,
  });

  const dynamicStyles: HTMLAttributes<HTMLElement>['style'] = {
    ...(style || {}),
    ...(size ? { fontSize: size } : undefined),
    ...(color ? { color: color } : undefined),
    ...(name === 'arrow_back_ios' ? { paddingLeft: 8 } : undefined), // This check centers back arrow icon to the center
  };

  return (
    <i aria-hidden={ariaHidden || true} className={iconStyles} style={dynamicStyles}>{name}</i>
  );
};

export default MaterialIcon;
